<template>
  <v-window v-model="tab">
    <v-window-item>
      <list ref="tab0" :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <detail ref="tab1" :open-tab="openTab" :item="item"/>
    </v-window-item>
    <v-window-item>
      <create-or-update ref="tab2" :open-tab="openTab" :item="item"/>
    </v-window-item>
  </v-window>
</template>

<script>

import List from "./List";
import Detail from "./Detail";
import CreateOrUpdate from "./CreateOrUpdate";
import mixin from "../../mixin";

export default {
  name: "SosCase",
  mixins: [mixin],
  components: {CreateOrUpdate, Detail, List},
  data() {
    return {
      item: null,
      tab: 0,
    };
  },
  methods: {
    openTab(tab, item) {
      this.tab = tab
      this.item = item
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(item)
    },
  },
}
</script>

<style scoped>

</style>